import * as yup from 'yup';

import { StringTypeBase } from '../../types/baseTypes/StringTypeBase';
import { FlexJustifyContentEnum } from '../../types/blocks/Flex';
import { TypeContextEnum } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_LANE } from '../constants';

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use FlexJustifyContentType from application-types instead.
 */
export class FlexJustifyContentType extends StringTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'FlexJustifyContent';

  friendlyName = 'Main-axis alignment.';

  contexts = [TypeContextEnum.Block, TypeContextEnum.Content];

  superUserOnly = false;

  get example() {
    return FlexJustifyContentEnum.Center;
  }

  get default(): any {
    return FlexJustifyContentEnum.Center;
  }

  buildSchema() {
    return yup.string().nullable().oneOf(Object.values(FlexJustifyContentEnum));
  }
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use FlexJustifyContent from application-types instead.
 */
const definition = new FlexJustifyContentType();

Types.addBaseType(definition);

export default definition;
